// export function AddLibrary(urlOfTheLibrary) {
//   const script = document.createElement("script");
//   script.src = urlOfTheLibrary;
//   script.async = true;
//   script.id = "script";
//   // document.body.removeChild(script)
//   document.body.appendChild(script);
// }

// export function RemoveOldScript(className) {
//   var oldScript = document.getElementById("script");
//   oldScript.remove();
// }

// import "./noframework.waypoints.js"
export function headerSet(docTitle) {
  var header = document.getElementById("header");
  header.classList.add("header-top");
  document.title = docTitle
}

export function headerReset(docTitle) {
  var header = document.getElementById("header");
  header.classList.remove("header-top");
  document.title = docTitle
}

export function animation(sectionName){
  const section = document.getElementById(sectionName);
    section.classList.remove("section-show");
    setTimeout(function () {
      section.classList.add("section-show");
    }, 350);
}

export function showNavLink(link, section_name) {
  const navLink = document.querySelectorAll(".nav-link");
  const active = document.getElementById(link);
  // const section = document.querySelector("section");
  // const active_section = document.getElementById(section_name);
  const navBar = document.querySelector("#navbar");
  navLink.forEach((item) => {
    item.classList.remove("active");
  });
  active.classList.add("active");
  // console.log(section)
  // console.log(active_section)
  // active_section.classList.remove('section-show')
  // active_section.classList.add('section-show')
  if (navBar.classList.contains("navbar-mobile")) {
    navBar.classList.remove("navbar-mobile");
    let navBarToggle = document.querySelector(".mobile-nav-toggle");
    navBarToggle.classList.toggle("bi-list");
    navBarToggle.classList.toggle("bi-x");
  }
}

export function mobileNav() {
  const navBar = document.querySelector("#navbar");
  navBar.classList.toggle("navbar-mobile");
  let navBarToggle = document.querySelector(".mobile-nav-toggle");
  navBarToggle.classList.toggle("bi-list");
  navBarToggle.classList.toggle("bi-x");
}

export function skillProgressAnimation(){
  let skilsContent = document.querySelector('.skills-content');
  if (skilsContent) {
    // new Waypoint({
      // element: skilsContent,
      // offset: '80%',
      // handler: function(direction) {
        setTimeout(function () {
          let progress = document.querySelectorAll('.progress .progress-bar', true);
        progress.forEach((el) => {
          el.style.width = el.getAttribute('aria-valuenow') + '%'
        });
        }, 1000);
        
      // }
    // })
  }
}

export function changeColor(varName,value){
  document.documentElement.style.setProperty(varName,value);
}
export function changeImage(varName,value){
  document.documentElement.style.setProperty(varName,value);
}